import { Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";

type Props = {
	label: string;
	onClick: () => void;
	truncate?: boolean;
};

export const ActionRow = ({ label, onClick, truncate = false }: Props) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="center"
			onClick={onClick}
			bgcolor={theme.palette.deprecated.grey[50]}
			sx={{ borderRadius: "12px", cursor: "pointer" }}
			px={1.6}
			py={1.2}
		>
			<Typography
				variant="deprecatedBody1"
				color={theme.palette.deprecated.grey[700]}
				sx={{
					flexGrow: 1,
					...(truncate
						? {
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}
						: {
								whiteSpace: "normal",
								overflowWrap: "break-word",
							}),
				}}
			>
				{label}
			</Typography>
			<ChevronRight size={16} color={theme.palette.primary.main} />
		</Stack>
	);
};
